<div fxLayout="row">

    <mat-card>
        <mat-card-content>
            <mat-card [fxHide]="!allowRecipientTypes">
                <mat-card-content>
                    <form [formGroup]="formGroup" novalidate fxLayout="column" fxLayoutGap="5px">
                        <mat-radio-group [fxHide]="!allowRunTypes" fxLayout="row" color="primary"
                            formControlName="runType" fxLayoutGap="5px">
                            <mat-radio-button value="PREVIEW">Preview Output</mat-radio-button>
                            <mat-radio-button value="OFFICIAL">Official EOD Output</mat-radio-button>
                        </mat-radio-group>
                        <mat-radio-group fxLayout="row" color="primary" formControlName="recipientType"
                            fxLayoutGap="5px">
                            <mat-radio-button value="SPECIFIC">Specified
                                Email Recipients</mat-radio-button>
                            <mat-radio-button value="FROM_CONFIGURATION">
                                Dashboard Configured Recipients</mat-radio-button>
                        </mat-radio-group>
                        <div fxLayout="row" [fxHide]="recipientType && recipientType.value !== 'SPECIFIC'">
                            <mat-form-field fxFlex="1 1 auto">
                                <mat-label>Recipients</mat-label>
                                <mat-select formControlName="recipients" multiple placeholder="Select email recipients">
                                    <mat-option *ngFor="let designer of designers" [value]="designer">
                                        {{designer}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button mat-icon-button color="primary" (click)="onClearRecipients()">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
            <!-- <mat-card>
                <mat-card-content>
                                 <mat-form-field>
                            <mat-label>Message</mat-label>
                            <textarea matInput placeholder="Enter email message here"
                                formControlName="message"></textarea>
                        </mat-form-field>
                    </mat-card-content>
                </mat-card> -->
            <mat-card>
                <mat-card-content>
                    <p-table fxFlex="1 1 auto" class="liquitics-box" [value]="reportDashboardNodes"
                        [columns]="['label']">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th style="text-align: center">Reports to Publish</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage" let-columns>
                            <tr>
                                <td>
                                    No reports selected
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr *ngIf="rowData.isMarked" [pSelectableRow]="rowData">
                                <td style="text-align: left">
                                    {{rowData['label']}}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </mat-card-content>
                <mat-card-footer fxLayout="row">
                    <button fxFlex="1 1 100%" mat-raised-button color="primary" [disabled]="!formGroup.valid"
                        (click)="onSend($event)">Send</button>
                </mat-card-footer>
            </mat-card>
        </mat-card-content>

    </mat-card>
</div>
<p-toast></p-toast>